import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TaxYearsState, taxYearsFeatureKey } from '../reducers/tax-years.reducer';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import * as taxYearsState from '../reducers/tax-years.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, TaxYearsState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee Tax Year SUB STATE
export const getTaxYearsState = createSelector(getMainEmployeeState, state => state[taxYearsFeatureKey]);
//#endregion

//#region Employee Tax year SUB STATE
export const getTaxYearsRequest = createSelector(getTaxYearsState, taxYearsState.getTaxYearsRequest);
export const getTaxYearsSuccess = createSelector(getTaxYearsState, taxYearsState.getTaxYearsResponse);
export const getTaxYearsFailure = createSelector(getTaxYearsState, taxYearsState.getTaxYearsFailure);

export const getTaxYearsIsLoaded = createSelector(getTaxYearsState, taxYearsState.getTaxYearsIsLoaded);
//#endregionrx/store';
